<template>
    <div v-if="delStatus" class="evaluate-card ptm mtm">
        <div class="clear evaluate-card__hd">
            <div class="left" @click="goTo(iteminfo.userInfo.id)"><avatar-box :avatar="iteminfo.userInfo.largeAvatar" :auth="iteminfo.userInfo.is_vip"></avatar-box></div>            
            <div class="clear evaluate-card__info">
                <div class="clear">
                    <div class="left c4 f2">{{iteminfo.userInfo.nickname}}</div>
                    <div class="right c9 fs1">{{createdtime}}</div>
                </div>
                <div class="evaluate-card__stars">
                    <van-rate v-model="value" :size="10" disabled-color="#FF6F0F" disabled />
                </div>
            </div>
        </div>
        <div class="evaluate-card__bd mtm c6 fs2">
            <div class="left">{{iteminfo.content || '好评'}}</div>
            <div v-if="this.type == 'manage'" class="del right blue" @click="del(iteminfo.id)">删除</div>
        </div>
        <!-- <van-row class="evaluate-card__ft tac mtm">
            <van-col span="8">
                <div class="evaluate-card__img"><img src="../assets/imgs/true.jpg"></div>
            </van-col>
            <van-col span="8">
                <div class="evaluate-card__img"><img src="../assets/imgs/true.jpg"></div>
            </van-col>
            <van-col span="8">
                <div class="evaluate-card__img"><img src="../assets/imgs/true.jpg"></div>
            </van-col>
        </van-row> -->
    </div>
</template>
<script>
import Vue from 'vue';
import AvatarBox from '@/components/AvatarBox';
import {Dialog,Toast} from 'vant';
Vue.use(Dialog).use(Toast);
import moment from 'moment';
moment.locale('zh-cn');
export default {
    name: 'EvaluateCard',
    components:{
        AvatarBox
    },
    props: {
      type:{},  //是否是管理员
      iteminfo:{}   //评价内容
    },
    data(){
        return {
            value: this.iteminfo.rating,
            delStatus:true  //删除状态 默认未删除
        }
    },
    computed: {
        createdtime: function () {
            return moment(this.iteminfo.createdTime*1000).format('YYYY-MM-DD HH:mm')
        },
    },
    methods: {
      goTo:function(id){
        location.href=`${location.origin}`+'/training/#/userHome?userId='+id      
      },        
      del:function(evaId){
        Dialog.confirm({
            title: '确定删除本条评价吗？',
        }).then(() => {
           // on confirm 
            this.$http.get('course_reviews/delete?id='+evaId).then(res => {
                if(!res.data.code){
                    Toast.success({
                       message:'删除成功！',
                       duration:1000 
                    })
                    this.delStatus = false 
                }else{
                    Toast.fail({
                        message:res.data.message,
                        duration:1000
                    })                        
                }                 
            })
        }).catch(() => {
        // on cancel
        });        
      }
    }
}
</script>
<style lang="less" scoped>
.evaluate-card{
    border-top: .01rem #f6f6f6 solid;
    &__info{
        overflow: hidden;
    }
    &__img{
        width: 1rem; height: 1rem;
        // margin: 0 auto;
        background-color: #f6f6f6;
        &>img{
            display: block;
            width: 100%;height: 100%;
            object-fit: cover;
        }
    }
    &__bd{
        overflow: hidden;
        & .del{
            text-decoration: underline;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluateCard.vue